var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalaJogos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 92.138 92.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sala_de_jogos_adulto",
    "data-name": "sala de jogos adulto",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1087",
    "data-name": "Caminho 1087",
    d: "M54.865,236.694a29.187,29.187,0,1,1,4.977,32.352c-4.762,6.094-11.013,9.347-18.773,9.328a22.093,22.093,0,0,1-15.049-5.82,23.038,23.038,0,0,1,28.845-35.86Zm52.438,12.6a26.092,26.092,0,1,0-26.082,26.062A26.076,26.076,0,0,0,107.3,249.294Zm-54.907-4.6c-.314-.02-.47-.039-.627-.039q-13.286,0-26.572-.02a1.12,1.12,0,0,0-1.117.686,19.707,19.707,0,0,0-.059,20.027,1.382,1.382,0,0,0,1.43.8c10.307-.02,20.595,0,30.9,0,.294,0,.607-.02,1.058-.059A29.206,29.206,0,0,1,52.4,244.689Zm3.077,24.592H27.1A19.711,19.711,0,0,0,55.472,269.282ZM26.921,241.574H52.2c.549,0,1,.02,1.117-.705.1-.627.509-1.117-.333-1.7a19.819,19.819,0,0,0-16.029-3.272A19.61,19.61,0,0,0,26.921,241.574Z",
    transform: "translate(-18.238 -186.196)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1088",
    "data-name": "Caminho 1088",
    d: "M21.694,47.317c1.979-.47,3.253.529,4.546,1.9Q40.525,64.237,54.928,79.14a4.6,4.6,0,1,1-6.506,6.506q-14.638-14.05-29.3-28.1a3,3,0,0,1-1.039-2.43c.059-1.94,0-3.9.02-5.859,0-1.47.49-1.96,1.96-1.96C20.616,47.317,21.145,47.317,21.694,47.317Zm-.509,3.155c0,1.274.039,2.528-.02,3.762a2.081,2.081,0,0,0,.764,1.744Q33.774,67.265,45.581,78.571c.274.255.549.509.705.666.8-.725,1.548-1.391,2.312-2.1-.274-.294-.47-.529-.705-.745-7.936-8.348-15.912-16.656-23.809-25A2.712,2.712,0,0,0,21.184,50.471ZM48.657,81.589c.745.725,1.45,1.47,2.214,2.136a1.46,1.46,0,0,0,2.077-.078,1.423,1.423,0,0,0,.1-2c-.666-.8-1.45-1.509-2.195-2.254C50.107,80.12,49.441,80.805,48.657,81.589Z",
    transform: "translate(-18.086 -47.198)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1089",
    "data-name": "Caminho 1089",
    d: "M239.559,202.638a1.572,1.572,0,0,1-1.646-2.195c.47-1.078,1.019-2.116,1.587-3.155a1.5,1.5,0,0,1,2.7,1.293,26.289,26.289,0,0,1-1.685,3.312C240.3,202.286,239.774,202.482,239.559,202.638Z",
    transform: "translate(-194.722 -167.228)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1090",
    "data-name": "Caminho 1090",
    d: "M121.321,235c.588.235.921.333,1.235.47.941.47,1.9.9,2.8,1.43a1.509,1.509,0,0,1-1.372,2.685c-1.1-.49-2.195-1.039-3.253-1.626a1.329,1.329,0,0,1-.627-1.8A5.251,5.251,0,0,1,121.321,235Z",
    transform: "translate(-99.998 -198.199)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1091",
    "data-name": "Caminho 1091",
    d: "M327.93,343.6a13.815,13.815,0,1,1-13.874-13.8A13.828,13.828,0,0,1,327.93,343.6Zm-3.076.039A10.738,10.738,0,1,0,314.1,354.373,10.8,10.8,0,0,0,324.853,343.634Z",
    transform: "translate(-244.999 -274.422)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1092",
    "data-name": "Caminho 1092",
    d: "M104.262,361.2a7.64,7.64,0,0,1,7.662,7.681,7.662,7.662,0,1,1-15.324,0A7.627,7.627,0,0,1,104.262,361.2Zm.02,3.076a4.555,4.555,0,0,0-4.625,4.6,4.6,4.6,0,1,0,9.19-.039A4.533,4.533,0,0,0,104.281,364.277Z",
    transform: "translate(-81.215 -299.669)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1093",
    "data-name": "Caminho 1093",
    d: "M340.646,370.272c.647-3.037,2.449-4.507,5.193-4.272a4.555,4.555,0,0,1,4.076,4.37c.1,2.391-1.587,4.272-4.233,4.742-1.215,3.351-2.861,4.664-5.369,4.311a4.615,4.615,0,0,1-3.919-4.429C336.334,372.663,337.863,370.919,340.646,370.272Zm.353,3.057a1.6,1.6,0,0,0-1.587,1.489,1.543,1.543,0,0,0,1.489,1.568,1.529,1.529,0,0,0,.1-3.057Zm5.839-2.783A1.543,1.543,0,0,0,345.329,369a1.5,1.5,0,0,0-1.548,1.47,1.529,1.529,0,0,0,3.057.078Z",
    transform: "translate(-274.018 -303.509)",
    fill: "#cb8f55"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaJogos);
export default __webpack_public_path__ + "static/media/sala-jogos.42b87b80818aaff8100c497b648803ab.svg";
export { ForwardRef as ReactComponent };